import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 5A5BC824-220B-4998-883A-0E57FB2AB75F
 * name backburger
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/backburger.svg
 * tags
 */
export const BackburgerIcon = createSvgIcon(<><path d="M5,13L9,17L7.6,18.42L1.18,12L7.6,5.58L9,7L5,11H21V13H5M21,6V8H11V6H21M21,16V18H11V16H21Z" /></>, 'BackburgerIcon');
export default BackburgerIcon